import React from 'react';
import styled from 'styled-components';
import Colors from '../Colors';

interface Props {
  message: string;
  style?: React.CSSProperties | undefined;
}

const FormFieldError: React.FC<Props> = ({ message, style }) => {
  if (!message) return null;
  return (
    <ErrorWrapper role="error-message" style={style}>
      <p data-cy="error">{message}</p>
    </ErrorWrapper>
  );
};

export default FormFieldError;

const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;

  p {
    font-family: 'BrownStd';
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    color: ${Colors.red} !important;
    margin-top: 0;
  }

  p:empty {
    display: none;
  }
`;
